var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class ewJSONContractLine extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.eier = 0;
        /** @override */ this.id = 0;
        /** @override */ this.isactive = false;
    }
}
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContractLine.prototype, "antall", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContractLine.prototype, "art_id", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContractLine.prototype, "artnr", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContractLine.prototype, "avtale", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONContractLine.prototype, "eier", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONContractLine.prototype, "id", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewJSONContractLine.prototype, "isactive", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContractLine.prototype, "pris", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContractLine.prototype, "startdato", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContractLine.prototype, "stopdato", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContractLine.prototype, "tekst", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContractLine.prototype, "tittel", void 0);
